"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteButton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.background.paper,
  boxShadow: _mui.SHADOW_LEVEL1,
  color: theme.palette.common.black,
  display: 'flex',
  fontSize: theme.typography.body1.fontSize,
  height: 20,
  justifyContent: 'center',
  left: theme.spacing(-1),
  position: 'absolute',
  top: theme.spacing(-1),
  width: 20,
  zIndex: 1,
  '&:hover': {
    background: theme.palette.background.paper,
    boxShadow: _mui.SHADOW_LEVEL3
  }
}));
const Icon = (0, _mui.styled)(_icons.Add)(({
  theme
}) => ({
  fontSize: '3.4rem',
  padding: theme.spacing(2),
  transform: 'rotate(45deg)'
}));
const DeleteButton = ({
  onClick
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
  type: "button",
  variant: "contained",
  onClick: onClick,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {})
});
exports.DeleteButton = DeleteButton;